import { RadioButtons } from '@dapp/multi-lib/sdaoui/RadioButtons';
import { useState } from 'react';
import { TabProvider, TabContent } from 'components/Tabs';
import { VaultAllocationTable } from 'structure/pv2/vault/components/VaultAllocationTable';
import { VaultFeeInfo } from 'structure/pv2/vault/components/VaultFeeInfo';
import { VaultReportingTable } from 'structure/pv2/vault/components/VaultReportingTable';
import { useTranslation } from 'react-i18next';
import { VaultIdentity } from 'structure/pv2/vault/utils/vault';

interface VaultDetailsProps {
  vaultIdentity: VaultIdentity;
  vaultDecimals: number;
}

export const VaultDetails = (props: VaultDetailsProps) => {
  const { vaultIdentity } = props;
  const { t } = useTranslation('vault');
  const [tableType, setTableType] = useState('compositions');

  return (
    <div>
      <div>
        <RadioButtons
          value={tableType}
          size='small'
          className='px-2 md:px-3'
          onChange={(value) => setTableType(value)}
          options={[
            { label: t('TABS.COMPOSITIONS'), value: 'compositions' },
            { label: t('TABS.FEE'), value: 'fee' },
            { label: t('TABS.REPORTING'), value: 'reporting' },
          ]}
        />
      </div>
      <TabProvider active={tableType}>
        <TabContent id='compositions'>
          <div className='mt-5'>
            <VaultAllocationTable vaultIdentity={vaultIdentity} />
          </div>
        </TabContent>
        <TabContent id='fee'>
          <div className='mt-5'>
            <VaultFeeInfo vaultIdentity={vaultIdentity} />
          </div>
        </TabContent>
        <TabContent id='reporting'>
          <div className='mt-5'>
            <VaultReportingTable
              vaultDecimals={props.vaultDecimals}
              vaultIdentity={vaultIdentity}
            />
          </div>
        </TabContent>
      </TabProvider>
    </div>
  );
};
